import React from 'react'

import FccOrderSkuList from './FccOrderSkuList'

const FccOrderSkuPage: React.FC = () => {
  return <FccOrderSkuList />
}

export default FccOrderSkuPage
